// 打印单据 HTML 模板（纯函数，不依赖 DOM，便于测试与复用）
import util from "../../../util/date";
import logo from "./logo";
import { contentHeight, expense } from "../printConfig";

// 报销单内容区可用高度（由打印配置推导），底部区块贴到该高度底部
const EXPENSE_CONTENT_H = contentHeight(expense);

const fmtDate = (v, pattern) =>
  !v ? "" : util.formatDate.format(new Date(v), pattern || "yyyy-MM-dd");
const fmtMoney = (v) => util.formatNum.numFormat(v);

const CHECK = "&nbsp;√&nbsp;";
const CROSS = "&nbsp;×&nbsp;";

// ============================================================
// 个人费用报销检验回执单（A4 纵向）
// entryList: [{ Entry, EntryInvoiceinfo, CreateBy, BillNo }]
// ============================================================
export function buildReceiptHtml(entryList) {
  const pages = (entryList || []).map((info) => buildReceiptPage(info));
  return pages.join('<div style="page-break-after: always;"></div>');
}

function buildReceiptPage(info) {
  const entryRows = (info.Entry || [])
    .map(
      (el, i) => `<tr align="center">
        <td>${i + 1}</td><td>${el.StaffName}</td><td>${el.CostDepName}</td>
        <td>${el.SubjectName}</td><td>${el.CostName}</td><td>${fmtMoney(el.Amount)}</td>
      </tr>`
    )
    .join("");

  // 发票校验信息：按项目分组汇总
  const invoiceList = JSON.parse(JSON.stringify(info.EntryInvoiceinfo || []));
  let isgou = true;
  invoiceList.forEach((o) => {
    if (o.Type === 99) o.InvoiceNo = "/";
    if (o.IsUpByPeo === "1") o.InvoiceNo = o.InvoiceNo + "*";
    if (util.formatDate.datedifference(o.InvoiceDate, new Date()) > 365)
      isgou = false;
  });

  const groups = Array.from(new Set(invoiceList.map((o) => o.ItemName)));
  const clinfo = groups.map((name) => {
    const items = invoiceList.filter((o) => o.ItemName === name);
    return {
      ItemName: name,
      zs: items.reduce((p, c) => p + c.Count, 0),
      InvoiceNo: items.map((o) => o.InvoiceNo).join(","),
      Amount: items.reduce((p, c) => p + c.Amount, 0).toFixed(2),
      InvoiceDate: items.map((o) => o.InvoiceDate).join(","),
    };
  });
  clinfo.push({
    ItemName: "合计",
    zs: clinfo.reduce((p, c) => p + c.zs, 0),
    InvoiceNo: "",
    Amount: clinfo.reduce((p, c) => p + parseFloat(c.Amount), 0).toFixed(2),
    InvoiceDate: "",
  });

  const invoiceRows = clinfo
    .map((el, i) => {
      const nos = el.InvoiceNo.split(",")
        .filter((s) => s)
        .map((s) => `<div>${s}</div>`)
        .join("");
      const dates = el.InvoiceDate.split(",")
        .filter((s) => s)
        .map((s) => `<div>${fmtDate(s)}</div>`)
        .join("");
      return `<tr align="center">
        <td>${i + 1}</td><td>${el.ItemName}</td><td>${nos}</td>
        <td>${fmtMoney(el.Amount)}</td><td>${dates}</td><td>${el.zs}</td>
      </tr>`;
    })
    .join("");

  return `<div>
    <div style="text-align:center;font-size:0.75em;">江苏辉源供应链管理有限公司</div>
    <div style="text-align:center;font-size:1.375em;font-weight:bold;letter-spacing:2px;margin-top:12px;">个人费用报销检验回执单</div>
    <div style="text-align:right;margin:16px 0 0;line-height:1.7;">
      编号：${info.BillNo}<br/>打印日期：${fmtDate(new Date())}
    </div>
    <div style="margin:2px 0 4px;">报销人信息：</div>
    <table style="table-layout:fixed;">
      <colgroup>
        <col style="width:10%" /><col style="width:15%" /><col style="width:20%" />
        <col style="width:20%" /><col style="width:20%" /><col style="width:15%" />
      </colgroup>
      <tr align="center"><td>序号</td><td>报销人</td><td>归属部门</td><td>项目名称</td><td>费用类型</td><td>金额</td></tr>
      ${entryRows}
    </table>
    <div style="margin:18px 0 4px;">发票校验详情：</div>
    <table style="table-layout:fixed;">
      <colgroup>
        <col style="width:9%" /><col style="width:26%" /><col style="width:29%" />
        <col style="width:12.5%" /><col style="width:16%" /><col style="width:7.5%" />
      </colgroup>
      <tr align="center"><td>序号</td><td>项目</td><td>发票号码</td><td>金额</td><td>开票日期</td><td>张数</td></tr>
      ${invoiceRows}
    </table>
    <table class="plain" style="margin:20px 0 6px;">
      <tr>
        <td>本次发票校验结果如下：</td>
        <td style="text-align:right;">报销人：${info.CreateBy}</td>
      </tr>
    </table>
    <table style="width:auto;font-size:0.875em;">
      <tr><td style="white-space:nowrap;">1.发票无重复</td><td align="center" style="padding:1px 2px;">${CHECK}</td></tr>
      <tr><td style="white-space:nowrap;">2.发票日期在365天内</td><td align="center" style="padding:1px 2px;">${isgou ? CHECK : CROSS}</td></tr>
      <tr><td style="white-space:nowrap;">3.购买方信息准确</td><td align="center" style="padding:1px 2px;">${CHECK}</td></tr>
      <tr><td style="white-space:nowrap;">4.本次校验总金额在预算范围内</td><td align="center" style="padding:1px 2px;">${CHECK}</td></tr>
    </table>
  </div>`;
}

// ============================================================
// 费用报销单（A4 横向，页面可用高度 210mm - 上下各 10mm 留白 = 190mm）
// info: { Entry, Remark, SKFMC, SKFKHYH, SKFYHZH }
// isDG: 是否对公（对公显示收款方信息，个人显示付款方式）
// ============================================================
const REMARK_NOTE = `备注:
1、差旅费 ≤ 2000元签批至江苏辉源财务总监，差旅费 ＞ 2000元，需江苏辉源总经理签批。
     招待费 ≤ 1000元签批至江苏辉源财务总监，招待费 ＞ 1000元，江苏辉源总经理签批。
     零星交通费 ≤ 300元签批至江苏辉源财务总监，零星交通费 ＞ 300元签批至江苏辉源总经理。
2、报销单中以*标记字段为必填字段，各报销人员需按业务实质填列，若不按要求填列，财务部有权退回直至调整规范。`;

const EXPENSE_DESC =
  "发生“招待费”和“其他费用”时，列出何处发生，联系人姓名，职务，代表公司<br/>发生“差旅费”，列明出差事由。如有新项目，请写明。";

export function buildExpenseHtml(info, isDG) {
  const entry = (info.Entry || []).map((el) => ({ ...el }));
  const sum = entry.reduce((p, c) => p + (parseFloat(c.Amount) || 0), 0);
  entry.push({
    RBDate: "",
    BillNo: "合计",
    StaffName: "",
    CostDepName: "",
    SubjectName: "",
    YSDATE: "",
    CostName: "",
    Amount: sum.toFixed(2),
  });

  const rows = entry
    .map(
      (el) => `<tr align="center">
        <td>${el.BillNo}</td><td>${fmtDate(el.RBDate)}</td><td>${el.StaffName}</td>
        <td>${el.CostDepName}</td><td>${el.SubjectName}</td>
        <td>${fmtDate(el.YSDATE, "yyyy-MM")}</td><td>${el.CostName}</td>
        <td>${fmtMoney(el.Amount)}</td>
      </tr>`
    )
    .join("");

  const underline = (w) =>
    `<span style="border-bottom:1px solid #000;display:inline-block;width:${w}mm;height:14px;vertical-align:bottom;">&nbsp;</span>`;
  const checkbox =
    '<input type="checkbox" checked="checked" style="width:13px;height:13px;vertical-align:-2px;" />';

  // 个人：付款方式在左、"冲个人借款"靠最右；对公：收款方信息从左铺满整行
  const payLine = isDG
    ? `<div style="display:flex;flex-wrap:wrap;font-weight:bold;font-size:0.7em;margin:2mm 0 4mm;">
        <span style="white-space:nowrap;margin-right:3mm;">是否对公：${checkbox}</span>
        <span style="white-space:nowrap;margin-right:3mm;">收款方名称：${info.SKFMC || ""}${underline(9)}</span>
        <span style="white-space:nowrap;margin-right:3mm;">收款方开户银行：${info.SKFKHYH || ""}${underline(9)}</span>
        <span style="white-space:nowrap;">收款方银行账号：${info.SKFYHZH || ""}${underline(9)}</span>
      </div>`
    : `<div style="display:flex;justify-content:space-between;align-items:baseline;font-size:0.8em;margin:2mm 0 4mm;">
        <span style="white-space:nowrap;">
          付款方式：&nbsp;${checkbox}&nbsp;转卡&nbsp;&nbsp;
          卡号${underline(68)}
        </span>
        <span style="white-space:nowrap;">冲个人借款</span>
      </div>`;

  const compiler = isDG ? "项金琳" : "潘阿慧";
  const coSign =
    "程庆苗、王飞飞、汪勇、陈亚宁、何清、韩晶、吴君、张剑";

  // 商务性支出 + 财务审核区域：宽度为上方明细表的 88%，整套左对齐
  const bizBlock = `<table style="width:88%;table-layout:fixed;font-size:0.75em;">
    <colgroup>
      <col style="width:13%" /><col style="width:61%" />
      <col style="width:13%" /><col style="width:13%" />
    </colgroup>
    <tr>
      <td style="height:11mm;vertical-align:middle;">商务性支出：</td>
      <td style="text-align:left;vertical-align:top;padding:3mm 4px 2px;">${EXPENSE_DESC}</td>
      <td colspan="2" align="center" style="vertical-align:middle;">财务审核</td>
    </tr>
    <tr>
      <td colspan="2" rowspan="2" style="text-align:left;vertical-align:top;padding:1px 4px;">
        商务性支出声明：${info.Remark || ""}
      </td>
      <td align="center" style="height:14.5mm;vertical-align:middle;">财务总监</td>
      <td align="center" style="vertical-align:middle;">审核会计</td>
    </tr>
    <tr>
      <td style="height:12.5mm;"></td>
      <td></td>
    </tr>
  </table>`;

  return `<div style="height:${EXPENSE_CONTENT_H}mm;display:flex;flex-direction:column;">
    <div style="position:relative;height:26mm;">
      <img src="${logo}" style="position:absolute;left:0;top:0;width:34mm;" />
      <div style="position:absolute;right:0;top:4mm;font-size:0.75em;">江苏辉源供应链管理有限公司</div>
      <div style="position:absolute;left:0;right:0;top:9mm;text-align:center;font-size:2.05em;font-weight:bold;letter-spacing:6px;">费用报销单</div>
    </div>
    ${payLine}
    <table>
      <tr align="center"><td>编号</td><td>费用发生日期</td><td>姓名</td><td>费用归属部门</td><td>项目</td><td>预算区间</td><td>费用类型</td><td>总计</td></tr>
      ${rows}
    </table>

    <div style="margin-top:auto;">
      ${bizBlock}
      <table class="plain" style="font-size:0.8em;margin-top:8mm;">
        <tr>
          <td>报销人签名：</td><td>部门经理批准：</td><td>总监批准：</td>
          <td>费用归属总监批准：</td><td>总经理批准：</td>
        </tr>
      </table>
      <div style="border-top:1px solid #000;margin-top:5mm;padding-top:2mm;font-size:0.75em;">
        <div style="white-space:pre-line;line-height:1.5;">${REMARK_NOTE}</div>
      </div>
      <div style="display:flex;font-size:0.8em;margin-top:3mm;">
        <span style="display:inline-block;width:41mm;">编制：${compiler}</span>
        <span>会签：${coSign}</span>
      </div>
    </div>
  </div>`;
}
